import Int from './Int';
import t from 'tcomb';
import formatDate from 'simple-format-date';

const Datetime = t.refinement(Int, () => true, 'Datetime');

Datetime.format = function(millis: Datetime, template: t.String) {
  return formatDate(new Date(millis), { template });
};

export default Datetime;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Datetime.js
 **/